var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isConditionMet
    ? _c(
        "div",
        {
          style:
            "width: 100%; padding-top: " +
            (_vm.item.pt || 0) +
            "px; padding-bottom: " +
            (_vm.item.pb || 0) +
            "px!important",
          on: {
            click: function($event) {
              return _vm.$emit("click", $event)
            }
          }
        },
        [
          _vm.item.url
            ? _c("pdf-embed", {
                class: "form-pdf align-" + (_vm.item.alignment || "center"),
                style: "width: " + (_vm.item.scale || 100) + "%",
                attrs: {
                  url: _vm.item.url,
                  "file-name": _vm.item.fileName,
                  interactive: !_vm.builder
                }
              })
            : _c(
                "div",
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "material-symbols-outlined",
                      attrs: { size: "100" }
                    },
                    [_vm._v("picture_as_pdf")]
                  )
                ],
                1
              )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }